// ID generation service
import { nanoid } from 'nanoid';

// Conversation/thread ids. Uses nanoid's full 21-char default (~126 bits) —
// NOT a short id — because thread ids are generated client-side and share a
// single per-tenant namespace. With embedded chat (show_history), many
// distinct end-users mint ids inside one tenant, and the backend appends to
// an existing thread_id on collision, so a short id risked silently merging
// two users' conversations. 21 chars makes that collision astronomically
// unlikely. (Name kept for compatibility with existing call sites.)
export function shortid() {
  return nanoid();
}

